import { z } from "zod";
import { intl } from "LocaleWrapper";
import { AgreementConditionType, CallType, ReeferCheckType } from "__generated__/graphql";
import { AgreementConditionRow, getRequiredConditionFields } from "view/agreements/validation/requiredUtils";
import { isTopLevelPath } from "view/agreements/validation/pathUtils";
import { throwError } from "@validation/utils/schemaUtils";

export type AgreementConditionOutput = z.output<typeof AgreementConditionValidationSchema>;

export const AgreementConditionValidationSchema = z.object({
	id: z.number().nullish(),
	type: z.enum(AgreementConditionType).nullish()
		.refine((data) => data != null, {
			message: intl.formatMessage({ id: "REQUIRED" }),
		}),
	product: z.object({
		id: z.number(),
		code: z.string().nullish(),
		name: z.string().nullish(),
	}).nullish(),
	location: z.object({
		id: z.number(),
		description: z.string().nullish(),
	}).nullish(),
	locationActionType: z.enum(CallType).nullish(),
	fromLocation: z.object({
		id: z.number(),
		description: z.string().nullish(),
	}).nullish(),
	toLocation: z.object({
		id: z.number(),
		description: z.string().nullish(),
	}).nullish(),
	empty: z.boolean().nullish(),
	ship: z.object({
		id: z.number(),
		name: z.string().nullish(),
	}).nullish(),
	waterLevelLocation: z.number().nullish(),
	waterLevelMin: z.number().nullish(),
	waterLevelMax: z.number().nullish(),
	reeferCheckType: z.enum(ReeferCheckType).nullish(),
}).superRefine((row, ctx) => {
	const requiredFields = getRequiredConditionFields({
		calculationMethodType: null,
		conditionType: row.type ?? undefined,
		condition: row,
	}) ?? [];

	requiredFields.forEach((x) => {
		if (x.path == null) {
			return;
		}

		const path = x.path;

		if (isTopLevelPath(path)) {
			const key = path as keyof AgreementConditionRow;
			const value = row[key];

			const isEmpty = (
				value == null
				|| (typeof value === "string" && value.trim().length === 0)
			);

			if (isEmpty) {
				throwError([ `${x.path}` ], ctx);
				return;
			}
		}
	});
});
